
export class FacultyMedicalProcedureModel{
 Id:string;
 CategoryName:string;
 CategoryId:string;
 FacultyId:string;
 FacultyName:string;
 ProcedureCode:string;
 MedicalProcedureName:string;
 Name:string;                       // this is same sa MedicalProcedureName useful for direct saving into db ,see EF FacultyMedicalProcedure model 
 FacultyFellowshipSpecialisationId:string;
 FacultyFellowshipSpecialisationName:string;
 CasesCount:number;
 AcceptAttachment:boolean;
 PerformAtHospital:boolean;
 PerformAtHospitalCasesCount:number;
 ProgramCategoryId:number;
 IsPatientProcedure:boolean;
 Status:boolean;
}
        
        